// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-88fe365e]:export{primaryColor:#525ca3;secondaryColor:#88a2d1;accentColor:#c41230}", ""]);
// Exports
module.exports = exports;
